module.exports = __webpack_public_path__ + "static/media/arrow_forward.f6f23d6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_forward.svg
// module id = 181
// module chunks = 0